<template>
  <v-layout wrap>
    <v-flex xs12 class="mb-3">
      <h3 class="text-xs-center">{{fDate()}}</h3>
      <br>
      <v-sheet height="500">
        <v-calendar
          ref="calendar"
          v-model="start"
          :type="type"
          :weekdays="[1,2,3,4,5,6,0]"
          color="primary"
        ></v-calendar>
      </v-sheet>
    </v-flex>

    <v-flex sm2 xs12 class="text-sm-left text-xs-center">
      <v-btn @click="$refs.calendar.prev()">
        <v-icon dark left>keyboard_arrow_left</v-icon>M
      </v-btn>
    </v-flex>
    <v-flex sm2 xs12 class="text-sm-left text-xs-center">
      <v-btn @click="setday('prevyear')">
        <v-icon dark left>keyboard_arrow_left</v-icon>Y
      </v-btn>
    </v-flex>

    <!-- <v-flex sm4 xs12 class="text-xs-center">
      <v-select v-model="type" :items="typeOptions" label="Type"></v-select>
    </v-flex>-->
    <v-flex sm4 xs12 class="text-xs-center">
      <v-btn @click="setday('today')" label="Today">Today</v-btn>
    </v-flex>
    <v-flex sm2 xs12 class="text-sm-right text-xs-center">
      <v-btn @click="setday('nextyear')">
        Y
        <v-icon right dark>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-flex>
        <v-flex sm2 xs12 class="text-sm-right text-xs-center">
      <v-btn @click="$refs.calendar.next()">
        M
        <v-icon right dark>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
// console.log("Calender called");
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
export default {
  data: () => ({
    type: "month",
    start: "",
    // cTit: "",
    typeOptions: [
      { text: "Day", value: "day" },
      { text: "4 Day", value: "4day" },
      { text: "Week", value: "week" },
      { text: "Month", value: "month" },
      { text: "Custom Daily", value: "custom-daily" },
      { text: "Custom Weekly", value: "custom-weekly" }
    ]
  }),
  methods: {
    fDate: function() {
      var dd = new Date();
      // console.log("fDate dd: " + dd + " start" + this.start);
      if (typeof this.start == "string" && this.start != "") {
        dd = new Date(Date.parse(this.start));
      }
      // console.log("fDate type: " + typeof this.start, dd);
      var s = monthNames[dd.getMonth()] + " " + dd.getFullYear().toString();
      // console.log("fDate" + s);
      return s;
    },
    setday: function(newdate) {
      var dd = new Date();
      if (newdate == "today") {
        var s = dd.toISOString().slice(0, 10);
        // console.log("setday:" + s);
        this.start = s;
      } else {
        if (this.start != "") {
          dd = new Date(Date.parse(this.start));
        }
        var year = dd.getFullYear();
        var month = dd.getMonth() + 1;
        var day = dd.getDate();
        if (newdate == "prevyear") {
          var s = year - 1 + "-" + month + "-" + day;
          this.start = s;
        } else if (newdate == "nextyear") {
          var s = year + 1 + "-" + month + "-" + day;
          this.start = s;
        }
      }
    }
  }
};
</script>
